/** Tiny formatting helpers shared across pages. */

function span(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  return `${Math.floor(months / 12)}y`;
}

export function relTime(ts: number | null | undefined): string {
  if (!ts) return '—';
  const seconds = Math.floor(Date.now() / 1000) - ts;
  if (seconds < 0) return -seconds < 60 ? 'in under a minute' : `in ${span(-seconds)}`;
  if (seconds < 60) return 'just now';
  return `${span(seconds)} ago`;
}

/** Human-readable byte count, e.g. 1536 → "1.5 KB". */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function statusLabel(status: string): {
  label: string;
  tone: 'ok' | 'warn' | 'error' | 'muted';
} {
  switch (status) {
    case 'active':
      return { label: 'Active', tone: 'ok' };
    case 'provisioning':
      return { label: 'Provisioning', tone: 'muted' };
    case 'frozen':
      return { label: 'Disabled', tone: 'warn' };
    case 'failed':
      return { label: 'Failed', tone: 'error' };
    case 'rolled_back':
    case 'auto_rolled_back':
      return { label: 'Rolled back', tone: 'warn' };
    case 'pending':
      return { label: 'Pending', tone: 'muted' };
    case 'connected':
      return { label: 'Connected', tone: 'ok' };
    case 'down':
      return { label: 'Down', tone: 'warn' };
    case 'error':
      return { label: 'Error', tone: 'error' };
    case 'superseded':
      return { label: 'Superseded', tone: 'muted' };
    default:
      return { label: status, tone: 'muted' };
  }
}
